import React, { useState, useEffect } from 'react';
import style from "../../css/Recharge.module.css";
import { getBanks } from '../../components/Service/CreditService'
import Menu from './Menu';
import Cookies from 'js-cookie';
import PaymentService from "../../components/Service/NeoXService";
import HistoryRecharge from './HistoryRecharge';
import { createPayPal } from "../../components/Service/PaypalService";
import { useProfile } from '../../Context/ProfileContext';
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import PaymentTab from './PaymentTab';

function Recharge() {
    const paymentService = new PaymentService();
    const { profile } = useProfile();
    const [bank, setbank] = useState([]);
    const presetAmounts = [100000, 200000, 500000, 700000, 1000000];
    const [showCustomInput, setShowCustomInput] = useState(false);
    const [desIdData, setDesIdData] = useState(null);
    const [soTien, setSoTien] = useState(0);
    const [promoCode, setPromoCode] = useState(Cookies.get("promoApplied"));
    const [promoApplied, setPromoApplied] = useState("");

    const [promoteAmount, setpromoteAmount] = useState(null);
    const [isPromoApplied, setIsPromoApplied] = useState(false);
    const [promoCokies, setPromoCokies] = useState(null);
    const [errors, setErrors] = useState({
        atm: "",
        international: "",
        paypal: "",
        info: "",
        qr: ""
    });

    const [errorspromote, setErrorspromote] = useState({
        atm: "",
        international: "",
        paypal: "",
        info: "",
        qr: ""
    });
    const [notify, setNotify] = useState({
        atm: "",
        international: "",
        paypal: "",
        info: "",
        qr: ""

    });
    const [loading, setLoading] = useState(false);
    useLanguage();

    const { t } = useTranslation();
    const handleAmountClick = (amount) => {
        if (amount === "other") {
            setShowCustomInput(true);
            setSoTien("");
        } else {
            setShowCustomInput(false);
            setSoTien(amount);
        }
    };

    useEffect(() => {
        const fetchDesId = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/des-id`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Cookies.get("Token")}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setDesIdData(data);
            } catch (error) {
                console.error('Error fetching des-id data:', error);
            }
        };

        fetchDesId();
    }, []);

    useEffect(() => {
        const fetchdata = async () => {
            const getbanks = await getBanks();
            setbank(getbanks.data);
        }
        fetchdata()
    }, []);

    const [selectedOption, setSelectedOption] = useState("Credit Card");

    const handleClickMomo = () => {
        setSelectedOption("MoMo");
    }

    const handleClickThanhToanNoiDia = () => {
        setSelectedOption("Atm");
    }
    const handleClickThanhToanQuocTe = () => {
        setSelectedOption("Credit Card");
    }
    const handleClickThanhToanPayPal = () => {
        setSelectedOption("Paypal");
    }
    const handleClickThongtinthanhtoan = () => {
        setSelectedOption("Thông tin thanh toán");
    }

    const handleClickThanhToanQR = () => {
        setSelectedOption("QR");
    }

    const promocode = "TIDADIGI2000K";
    const amountpromote = 2000000;
    useEffect(() => {

        const newNotify = { atm: "", international: "", paypal: "", info: "", qr: "" };
        let newErrors = { atm: "", international: "", paypal: "", info: "", qr: "" };

        // if (promoCode.trim().toUpperCase() === promocode) {
        //     if (profile?.top_up !== 0 && profile?.utm_source !== 0) {
        //         if (selectedOption === "Atm") newNotify.atm = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
        //         if (selectedOption === "Credit Card") newNotify.international = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
        //         if (selectedOption === "Paypal") newNotify.paypal = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
        //         if (selectedOption === "QR") newNotify.qr = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";

        //     }


        // }


        if (promoCode === "") {
            if (selectedOption === "Atm") newErrors.atm = "";
            if (selectedOption === "Credit Card") newErrors.international = "";
            if (selectedOption === "Paypal") newErrors.paypal = "";
            if (selectedOption === "QR") newErrors.qr = "";

        }
        if (soTien > 100000) {
            if (selectedOption === "Atm") newErrors.atm = "";
            if (selectedOption === "Credit Card") newErrors.international = "";
            if (selectedOption === "Paypal") newErrors.paypal = "";
            if (selectedOption === "QR") newErrors.qr = "";
        }
        setErrorspromote(newErrors);
        setErrors(newErrors);
        setIsPromoApplied(false);

    }, [promoCode, selectedOption, soTien]);

    useEffect(() => {
        // Kiểm tra profile đã có giá trị chưa
        if (!profile) return;

        // Nếu profile có top_up == 0, xoá cookie
        if (profile?.top_up === 0) {
            console.log("logne");
            Cookies.remove("promoApplied");
        }

        const savedPromoApplied = Cookies.get("promoApplied");

        // Nếu savedPromoApplied tồn tại và đúng mã khuyến mãi
        if (savedPromoApplied && savedPromoApplied.toLocaleLowerCase() === promocode.toLocaleLowerCase()) {
            setIsPromoApplied(true);
            setPromoApplied(savedPromoApplied);
            setPromoCode(""); // Xóa mã khuyến mãi
            setpromoteAmount(2000000); // Cập nhật số tiền khuyến mãi
            setPromoCokies(savedPromoApplied); // Cập nhật giá trị cookie
        }
    }, [profile]); // useEffect phụ thuộc vào profile



    const handleRecharge = async () => {
        let newErrors = { atm: "", international: "", paypal: "", info: "", qr: "" };


        if (soTien < 100000) {
            if (selectedOption === "Atm") newErrors.atm = "Số tiền phải lớn hơn hoặc bằng 100,000";
            if (selectedOption === "Credit Card") newErrors.international = "Số tiền phải lớn hơn hoặc bằng 100,000";
            if (selectedOption === "Paypal") newErrors.paypal = "Số tiền phải lớn hơn hoặc bằng 100,000";
            if (selectedOption === "QR") newErrors.qr = "Số tiền phải lớn hơn hoặc bằng 100,000";

        }

        setErrors(newErrors);

        if (Object.values(newErrors).some(error => error !== "")) {
            return;
        }
        const updateTransaction = async (paymentMethod, gatewayId) => {
            try {
                const transactionResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/create-transaction`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${Cookies.get("Token")}`
                    },
                    body: JSON.stringify({
                        status: 0,
                        dep_id: desIdData?.dep_id,
                        amount: soTien,
                        gatewayId: gatewayId,
                        type: 2,
                        paymentMethod: paymentMethod
                    }),
                });

                if (!transactionResponse.ok) {
                    throw new Error(`Failed to create transaction for ${paymentMethod}`);
                }

            } catch (error) {
                console.error(`Error updating wallet for ${paymentMethod}:`, error);
            }
        };

        if (selectedOption == "Atm") {


            setLoading(true)
            await updateTransaction("ATM", 1)

            const paymentUrl = await paymentService.createPayment(
                soTien,
                desIdData?.dep_id,
                "ATM",
                "recharge",
                "",
                1,
                Cookies.get("promoApplied")
            );

            if (paymentUrl) {
                try {


                    window.location.href = paymentUrl;
                } catch (err) {
                    console.error("Error creating transaction:", err);
                    alert("There was an error processing the transaction.");
                }
            } else {
                setLoading(false);

                alert("Failed to generate payment URL.");
            }
        }
        else if (selectedOption == "Credit Card") {


            setLoading(true);
            await updateTransaction("Credit Card", 1)

            const paymentUrl = await paymentService.createPayment(
                soTien,
                desIdData?.dep_id,
                "CC",
                "recharge",
                "",
                1,
                promoCokies
            );

            if (paymentUrl) {
                try {
                    window.location.href = paymentUrl;
                } catch (err) {
                    console.error("Error creating transaction:", err);
                    alert("There was an error processing the transaction.");
                }
            } else {
                alert("Failed to generate payment URL.");
                setLoading(false)
            }
        }
        else if (selectedOption == "QR") {


            setLoading(true);
            await updateTransaction("QR", 1)

            const paymentUrl = await paymentService.createPayment(
                soTien,
                desIdData?.dep_id,
                "QR",
                "recharge",
                "",
                1,
                promoCokies
            );

            if (paymentUrl) {
                try {
                    window.location.href = paymentUrl;
                } catch (err) {
                    console.error("Error creating transaction:", err);
                    alert("There was an error processing the transaction.");
                }
            } else {
                alert("Failed to generate payment URL.");
                setLoading(false)
            }
        }
        else if (selectedOption == "Paypal") {

            setLoading(true);
            await updateTransaction("Paypal", 2)


            const paymentUrl = await createPayPal(desIdData?.dep_id, soTien, "recharge", 1, 1, promoCokies);

            if (paymentUrl) {
                try {
                    window.location.href = paymentUrl;
                } catch (err) {
                    console.error("Error creating transaction:", err);
                    alert("There was an error processing the transaction.");
                }
            } else {
                alert("Failed to generate payment URL.");
                setLoading(false);

            }
        }
    };

    const handleApplyPromo = () => {
        setIsPromoApplied(true)
        const newNotify = { atm: "", international: "", paypal: "", info: "", qr: "" };
        let newErrors = { atm: "", international: "", paypal: "", info: "", qr: "" };

        const trimmedPromoCode = promoCode?.trim().toUpperCase();

        if (trimmedPromoCode === promocode) {
            if (profile?.top_up > 0 && profile?.utm_source === 1) {
                if (selectedOption === "Atm") newNotify.atm = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
                if (selectedOption === "Credit Card") newNotify.international = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
                if (selectedOption === "Paypal") newNotify.paypal = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
                if (selectedOption === "QR") newNotify.qr = "Bạn được cộng thêm 2.000.000đ vào tài khoản khuyến mãi";
                setPromoApplied(promoCode);
                setpromoteAmount(amountpromote);
                setPromoCode("");
                Cookies.set("promoApplied", promoCode, { expires: 30 });
            }
        }

        if (trimmedPromoCode === promocode) {
            if (selectedOption === "Atm") newErrors.atm = "";
            if (selectedOption === "Credit Card") newErrors.international = "";
            if (selectedOption === "Paypal") newErrors.paypal = "";
            if (selectedOption === "QR") newErrors.qr = "";
        }

        const isBonusPromo = trimmedPromoCode !== "" && trimmedPromoCode !== promocode;
        if (isBonusPromo) {
            if (selectedOption === "Atm") newErrors.atm = "Mã khuyến mãi không hợp lệ";
            if (selectedOption === "Credit Card") newErrors.international = "Mã khuyến mãi không hợp lệ";
            if (selectedOption === "Paypal") newErrors.paypal = "Mã khuyến mãi không hợp lệ";
            if (selectedOption === "QR") newErrors.qr = "Mã khuyến mãi không hợp lệ";
        }

        if (trimmedPromoCode === promocode) {
            if (profile?.utm_source !== 1) {
                if (selectedOption === "Atm") newErrors.atm = "Mã khuyến mãi chỉ áp dụng khi đăng ký tại chương trình khuyến mãi";
                if (selectedOption === "Credit Card") newErrors.international = "Mã khuyến mãi chỉ áp dụng khi đăng ký tại chương trình khuyến mãi";
                if (selectedOption === "Paypal") newErrors.paypal = "Mã khuyến mãi chỉ áp dụng khi đăng ký tại chương trình khuyến mãi";
                if (selectedOption === "QR") newErrors.qr = "Mã khuyến mãi chỉ áp dụng khi đăng ký tại chương trình khuyến mãi";
            } else if (profile?.top_up < 1) {
                if (selectedOption === "Atm") newErrors.atm = "Mã khuyến mãi này đã được sử dụng trước đó và không thể áp dụng lại.";
                if (selectedOption === "Credit Card") newErrors.international = "Mã khuyến mãi này đã được sử dụng trước đó và không thể áp dụng lại.";
                if (selectedOption === "Paypal") newErrors.paypal = "Mã khuyến mãi này đã được sử dụng trước đó và không thể áp dụng lại.";
                if (selectedOption === "QR") newErrors.qr = "Mã khuyến mãi này đã được sử dụng trước đó và không thể áp dụng lại.";
            }
        }

        setErrorspromote(newErrors);
        setNotify(newNotify);
    }

    const handleCancelPromo = () => {
        setPromoCode('');
        setIsPromoApplied(false);
        setpromoteAmount(null);
        Cookies.remove("promoApplied");
    };
    console.log("soTien", soTien)
    const totalTopup = () => {
        let total = Number(soTien) + (Number(promoteAmount) || 0);
        return total;
    }


    // const thanhToanNoiDia = () => {
    //     return (
    //         <>
    //             <div className={style.paymentContainer}>


    //                 <div className="row justify-content-center">
    //                     <div className="col-md-6 mb-4">
    //                         <label className="form-label fw-semibold">
    //                             Nạp tiền
    //                         </label>
    //                         <div className={style.buttonGroup}>
    //                             {presetAmounts.map((amount) => (
    //                                 <button
    //                                     key={amount}
    //                                     type="button"
    //                                     className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
    //                                     onClick={() => handleAmountClick(amount)}
    //                                 >
    //                                     {amount.toLocaleString()}
    //                                 </button>
    //                             ))}
    //                             <button
    //                                 onClick={() => handleAmountClick("other")}
    //                                 type="button"
    //                                 className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
    //                             >
    //                                 {t("Other")}
    //                             </button>
    //                         </div>

    //                         {showCustomInput && (
    //                             <input
    //                                 type="number"
    //                                 className="form-control mt-2"
    //                                 placeholder="Nhập số tiền..."
    //                                 min="100000"
    //                                 value={soTien}
    //                                 style={{ width: '70%' }}
    //                                 onChange={(e) => setSoTien(e.target.value)}
    //                                 required
    //                             />
    //                         )}
    //                         {/* {eror && (
    //                             <p className="text-success mt-1">Số tiền phải lớn hơn hoặc bằng 100,000</p>
    //                         )
    //                         } */}


    //                     </div>

    //                     <div className="col-md-6 mb-4">
    //                         <label className="form-label fw-semibold">
    //                             Mã khuyến mãi
    //                         </label>
    //                         <input
    //                             type="text"
    //                             className="form-control"
    //                             placeholder="Nhập mã khuyến mãi"
    //                             style={{ width: '70%' }}
    //                             value={promoCode}
    //                             onChange={(e) => setPromoCode(e.target.value)}
    //                             required
    //                         />
    //                         {selectedOption === "Atm" && errors.atm && (
    //                             <p className="text-danger mt-1">⚠️ {errors.atm}</p>
    //                         )}
    //                         {selectedOption === "Atm" && notify.atm && (
    //                             <p className="text-success mt-1">✅ {notify.atm}</p>
    //                         )}


    //                     </div>




    //                 </div>

    //                 <div className="">
    //                     <button
    //                         type="button"
    //                         className="btn btn-primary mt-3"
    //                         onClick={handleRecharge}
    //                         disabled={loading}
    //                     >
    //                         {loading ? <span className="spinner-border spinner-border-sm"></span> : t("Add funds")}
    //                     </button>
    //                 </div>

    //                 <div style={{ width: "1000px", marginTop: "20px" }} className="row">
    //                     {["ACB", "HDBank", "MB Bank", "PVcombank"].map((bank, index) => (
    //                         <div key={index} className="col-3 d-flex justify-content-center">
    //                             <div className="border p-2" style={{ width: "70%", textAlign: "center" }}>
    //                                 <img
    //                                     src={`/images/logobank/Logo ${bank}.svg`}
    //                                     className="img-fluid"
    //                                     style={{ maxHeight: "100px", objectFit: "contain" }}
    //                                     alt={`Logo ${bank}`}
    //                                 />
    //                             </div>
    //                         </div>
    //                     ))}
    //                 </div>
    //                 <div style={{ width: "1000px", marginTop: "20px" }} className="row">
    //                     {["Sacombank", "SHB", "TCB", "TPBank"].map((bank, index) => (
    //                         <div key={index} className="col-3 d-flex justify-content-center">
    //                             <div className="border p-2" style={{ width: "70%", textAlign: "center" }}>
    //                                 <img
    //                                     src={`/images/logobank/Logo ${bank}.svg`}
    //                                     className="img-fluid"
    //                                     style={{ maxHeight: "100px", objectFit: "contain" }}
    //                                     alt={`Logo ${bank}`}
    //                                 />
    //                             </div>
    //                         </div>
    //                     ))}
    //                 </div>
    //                 <div style={{ width: "1000px", marginTop: "20px", marginBottom: "30px" }} className="row">
    //                     {["Vietcombank", "VietinBank", "VPBank", "Agribank"].map((bank, index) => (
    //                         <div key={index} className="col-3 d-flex justify-content-center">
    //                             <div className="border p-2" style={{ width: "70%", textAlign: "center" }}>
    //                                 <img
    //                                     src={`/images/logobank/Logo ${bank}.svg`}
    //                                     className="img-fluid"
    //                                     style={{ maxHeight: "100px", objectFit: "contain" }}
    //                                     alt={`Logo ${bank}`}
    //                                 />
    //                             </div>
    //                         </div>
    //                     ))}
    //                 </div>
    //             </div>
    //         </>
    //     );
    // }


    const thanhToanNoiDia = () => {
        return (
            <>
                <div className={style.paymentContainer}>
                    <p className="text-center fw-bold"></p>

                    <div className="row justify-content-center">
                        <div className="col-md-6 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Add funds")}
                            </label>
                            <div className={style.buttonGroup}>
                                {presetAmounts.map((amount) => (
                                    <button
                                        key={amount}
                                        type="button"
                                        className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
                                        onClick={() => handleAmountClick(amount)}
                                    >
                                        {amount.toLocaleString()}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handleAmountClick("other")}
                                    type="button"
                                    className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
                                >
                                    Khác
                                </button>
                            </div>

                            {showCustomInput && (
                                <input
                                    type="number"
                                    className="form-control mt-2"
                                    placeholder="Nhập số tiền..."
                                    min="100000"
                                    value={soTien}
                                    style={{ width: '70%' }}
                                    onChange={(e) => setSoTien(parseInt(e.target.value) || 0)}
                                    required
                                />

                            )}
                            <div className="my-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleRecharge}
                                >
                                    {t("Add funds")}
                                </button>
                            </div>

                            {selectedOption === "Atm" && errors.atm && (
                                <p className="text-danger mt-1">⚠️ {errors.atm}</p>
                            )}

                        </div>

                        <div className="col-md-5 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Summary")}
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nhập mã khuyến mãi"
                                    style={{ width: '70%' }}
                                    value={promoCode}
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    required
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ width: '30%' }}
                                    onClick={handleApplyPromo}
                                >
                                    {t("Apply")}
                                </button>


                                {selectedOption === "Atm" && errorspromote.atm && (
                                    <p className="text-danger mt-1">⚠️ {errorspromote.atm}</p>
                                )}
                            </div>
                            <div style={{ margin: "0px", padding: "0px" }} className="col-12">
                                <div className="border p-3 rounded" style={{ backgroundColor: "#f9f9f9" }}>
                                    {Cookies.get("promoApplied") && Cookies.get("promoApplied").toLocaleLowerCase() === promocode.toLocaleLowerCase() ? (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <span className="">{Cookies.get("promoApplied")} </span>
                                                <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(promoteAmount)} </span>
                                            </div>
                                            <div className='d-flex justify-content-between'>
                                                <span style={{ fontSize: "13px" }}> {t("Credit expires")} </span>
                                                <span
                                                    style={{ fontSize: "12px", border: "1px solid red", padding: "0 0", paddingLeft: "5px", paddingRight: "5px", backgroundColor: "red", color: "white", cursor: "pointer" }}
                                                    onClick={handleCancelPromo}
                                                >
                                                    {t("Delete")}
                                                </span>
                                            </div>
                                        </>
                                    ) : ""}

                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="">Số tiền:</span>
                                        <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(soTien)}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="fw-semibold">Tổng:</span>
                                        <span className="text-success">{new Intl.NumberFormat('vi-VN').format(totalTopup())}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="">

                    </div>


                </div>
            </>
        );
    }
    const thanhToanQuocTe = () => {
        return (
            <>
                <div className={style.paymentContainer}>
                    <p className="text-center fw-bold"></p>

                    <div className="row justify-content-center">
                        <div className="col-md-6 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Add funds")}
                            </label>
                            <div className={style.buttonGroup}>
                                {presetAmounts.map((amount) => (
                                    <button
                                        key={amount}
                                        type="button"
                                        className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
                                        onClick={() => handleAmountClick(amount)}
                                    >
                                        {amount.toLocaleString()}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handleAmountClick("other")}
                                    type="button"
                                    className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
                                >
                                    Khác
                                </button>
                            </div>

                            {showCustomInput && (
                                <input
                                    type="number"
                                    className="form-control mt-2"
                                    placeholder="Nhập số tiền..."
                                    min="100000"
                                    value={soTien}
                                    style={{ width: '70%' }}
                                    onChange={(e) => setSoTien(e.target.value)}
                                    required
                                />
                            )}
                            <div className="my-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleRecharge}
                                >
                                    {t("Add funds")}
                                </button>
                            </div>

                            {selectedOption === "Credit Card" && errors.international && (
                                <p className="text-danger mt-1">⚠️ {errors.international}</p>
                            )}

                        </div>

                        <div className="col-md-5 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Summary")}
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nhập mã khuyến mãi"
                                    style={{ width: '70%' }}
                                    value={promoCode}
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    required
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ width: '30%' }}
                                    onClick={handleApplyPromo}
                                >
                                    {t("Apply")}
                                </button>


                                {selectedOption === "Credit Card" && errorspromote.international && (
                                    <p className="text-danger mt-1">⚠️ {errorspromote.international}</p>
                                )}
                            </div>
                            <div style={{ margin: "0px", padding: "0px" }} className="col-12">
                                <div className="border p-3 rounded" style={{ backgroundColor: "#f9f9f9" }}>
                                    {Cookies.get("promoApplied") && Cookies.get("promoApplied").toLocaleLowerCase() === promocode.toLocaleLowerCase() ? (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <span className="">{Cookies.get("promoApplied")} </span>
                                                <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(promoteAmount)} </span>
                                            </div>
                                            <div className='d-flex justify-content-between'>
                                                <span style={{ fontSize: "13px" }}> {t("Credit expires")} </span>
                                                <span
                                                    style={{ fontSize: "12px", border: "1px solid red", padding: "0 0", paddingLeft: "5px", paddingRight: "5px", backgroundColor: "red", color: "white", cursor: "pointer" }}
                                                    onClick={handleCancelPromo}
                                                >
                                                    {t("Delete")}
                                                </span>
                                            </div>
                                        </>
                                    ) : ""}

                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="">Số tiền:</span>
                                        <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(soTien)}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="fw-semibold">Tổng:</span>
                                        <span className="text-success">{new Intl.NumberFormat('vi-VN').format(totalTopup())}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="">

                    </div>


                </div>
            </>
        );
    }

    const thanhToanQR = () => {
        return (
            <>
                <div className={style.paymentContainer}>
                    <p className="text-center fw-bold"></p>

                    <div className="row justify-content-center">
                        <div className="col-md-6 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Add funds")}
                            </label>
                            <div className={style.buttonGroup}>
                                {presetAmounts.map((amount) => (
                                    <button
                                        key={amount}
                                        type="button"
                                        className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
                                        onClick={() => handleAmountClick(amount)}
                                    >
                                        {amount.toLocaleString()}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handleAmountClick("other")}
                                    type="button"
                                    className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
                                >
                                    Khác
                                </button>
                            </div>

                            {showCustomInput && (
                                <input
                                    type="number"
                                    className="form-control mt-2"
                                    placeholder="Nhập số tiền..."
                                    min="100000"
                                    value={soTien}
                                    style={{ width: '70%' }}
                                    onChange={(e) => setSoTien(e.target.value)}
                                    required
                                />
                            )}
                            <div className="my-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleRecharge}
                                >
                                    {t("Add funds")}
                                </button>
                            </div>

                            {selectedOption === "QR" && errors.qr && (
                                <p className="text-danger mt-1">⚠️ {errors.qr}</p>
                            )}

                        </div>

                        <div className="col-md-5 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Summary")}

                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nhập mã khuyến mãi"
                                    style={{ width: '70%' }}
                                    value={promoCode}
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    required
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ width: '30%' }}
                                    onClick={handleApplyPromo}
                                >
                                    {t("Apply")}
                                </button>


                                {selectedOption === "QR" && errorspromote.qr && (
                                    <p className="text-danger mt-1">⚠️ {errorspromote.qr}</p>
                                )}
                            </div>
                            <div style={{ margin: "0px", padding: "0px" }} className="col-12">
                                <div className="border p-3 rounded" style={{ backgroundColor: "#f9f9f9" }}>
                                    {Cookies.get("promoApplied") && Cookies.get("promoApplied").toLocaleLowerCase() === promocode.toLocaleLowerCase() ? (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <span className="">{Cookies.get("promoApplied")} </span>
                                                <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(promoteAmount)} </span>
                                            </div>
                                            <div className='d-flex justify-content-between'>
                                                <span style={{ fontSize: "13px" }}> {t("Credit expires")} </span>
                                                <span
                                                    style={{ fontSize: "12px", border: "1px solid red", padding: "0 0", paddingLeft: "5px", paddingRight: "5px", backgroundColor: "red", color: "white", cursor: "pointer" }}
                                                    onClick={handleCancelPromo}
                                                >
                                                    {t("Delete")}
                                                </span>
                                            </div>
                                        </>
                                    ) : ""}

                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="">Số tiền:</span>
                                        <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(soTien)}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="fw-semibold">Tổng:</span>
                                        <span className="text-success">{new Intl.NumberFormat('vi-VN').format(totalTopup())}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="">

                    </div>


                </div>
            </>
        );
    }

    const thanhToanPayPal = () => {
        return (
            <>
                <div className={style.paymentContainer}>
                    <p className="text-center fw-bold"></p>

                    <div className="row justify-content-center">
                        <div className="col-md-6 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Add funds")}
                            </label>
                            <div className={style.buttonGroup}>
                                {presetAmounts.map((amount) => (
                                    <button
                                        key={amount}
                                        type="button"
                                        className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
                                        onClick={() => handleAmountClick(amount)}
                                    >
                                        {amount.toLocaleString()}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handleAmountClick("other")}
                                    type="button"
                                    className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
                                >
                                    Khác
                                </button>
                            </div>

                            {showCustomInput && (
                                <input
                                    type="number"
                                    className="form-control mt-2"
                                    placeholder="Nhập số tiền..."
                                    min="100000"
                                    value={soTien}
                                    style={{ width: '70%' }}
                                    onChange={(e) => setSoTien(e.target.value)}
                                    required
                                />
                            )}
                            <div className="my-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleRecharge}
                                >
                                    {t("Add funds")}
                                </button>
                            </div>

                            {selectedOption === "Paypal" && errors.paypal && (
                                <p className="text-danger mt-1">⚠️ {errors.paypal}</p>
                            )}

                        </div>

                        <div className="col-md-5 mb-4">
                            <label className="form-label fw-semibold">
                                {t("Summary")}
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nhập mã khuyến mãi"
                                    style={{ width: '70%' }}
                                    value={promoCode}
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    required
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ width: '30%' }}
                                    onClick={handleApplyPromo}
                                >
                                    {t("Apply")}
                                </button>


                                {selectedOption === "Paypal" && errorspromote.paypal && (
                                    <p className="text-danger mt-1">⚠️ {errorspromote.paypal}</p>
                                )}
                            </div>
                            <div style={{ margin: "0px", padding: "0px" }} className="col-12">
                                <div className="border p-3 rounded" style={{ backgroundColor: "#f9f9f9" }}>
                                    {Cookies.get("promoApplied") && Cookies.get("promoApplied").toLocaleLowerCase() === promocode.toLocaleLowerCase() ? (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <span className="">{Cookies.get("promoApplied")} </span>
                                                <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(promoteAmount)} </span>
                                            </div>
                                            <div className='d-flex justify-content-between'>
                                                <span style={{ fontSize: "13px" }}> {t("Credit expires")} </span>
                                                <span
                                                    style={{ fontSize: "12px", border: "1px solid red", padding: "0 0", paddingLeft: "5px", paddingRight: "5px", backgroundColor: "red", color: "white", cursor: "pointer" }}
                                                    onClick={handleCancelPromo}
                                                >
                                                    {t("Delete")}
                                                </span>
                                            </div>
                                        </>
                                    ) : ""}

                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="">Số tiền:</span>
                                        <span className="text-success"> {new Intl.NumberFormat('vi-VN').format(soTien)}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between mt-2">
                                        <span className="fw-semibold">Tổng:</span>
                                        <span className="text-success">{new Intl.NumberFormat('vi-VN').format(totalTopup())}</span>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="">

                    </div>


                </div>
            </>
        );
    }


    // const thanhToanPayPal = () => {
    //     return (
    //         <>
    //             <div className={style.paymentContainer}>

    //                 <p className="text-center fw-bold"></p>

    //                 <div className="row justify-content-center">
    //                     <div className="col-md-12 mb-4">
    //                         <label className="form-label fw-semibold">
    //                             Thanh Toán PayPal
    //                         </label>
    //                         <div className={style.buttonGroup}>
    //                             {presetAmounts.map((amount) => (
    //                                 <button
    //                                     key={amount}
    //                                     type="button"
    //                                     className={`${style.button} ${soTien == amount && !showCustomInput ? style.buttonActive : ""}`}
    //                                     onClick={() => handleAmountClick(amount)}
    //                                 >
    //                                     {amount.toLocaleString()}
    //                                 </button>
    //                             ))}
    //                             <button
    //                                 onClick={() => handleAmountClick("other")}
    //                                 type="button"
    //                                 className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
    //                             >
    //                                 Khác
    //                             </button>
    //                         </div>

    //                         {showCustomInput && (
    //                             <input
    //                                 type="number"
    //                                 className="form-control mt-2"
    //                                 placeholder="Nhập số tiền..."
    //                                 min="100000"
    //                                 value={soTien}
    //                                 style={{ width: '70%' }}
    //                                 onChange={(e) => setSoTien(e.target.value)}
    //                                 required
    //                             />
    //                         )}
    //                     </div>

    //                     <div className="col-md-12 mb-4">
    //                         <input
    //                             type="text"
    //                             className="form-control"
    //                             placeholder="Nhập mã khuyến mãi"
    //                             style={{ width: '70%' }}
    //                             value={promoCode}
    //                             onChange={(e) => setPromoCode(e.target.value)}
    //                             required
    //                         />
    //                         {selectedOption === "Paypal" && errors.paypal && (
    //                             <p className="text-danger mt-1">⚠️ {errors.paypal}</p>
    //                         )}
    //                         {selectedOption === "Paypal" && notify.paypal && (
    //                             <p className="text-success mt-1">✅ {notify.paypal}</p>
    //                         )}
    //                     </div>
    //                 </div>

    //                 <div className="">
    //                     <button
    //                         type="button"
    //                         className="btn btn-primary mt-3"
    //                         onClick={handleRecharge}
    //                         disabled={loading}
    //                     >
    //                         {loading ? <span className="spinner-border spinner-border-sm"></span> : t("Add funds")}
    //                     </button>

    //                 </div>


    //             </div>
    //         </>
    //     );
    // }

    const thongTinThanhToan = () => {
        const banks = [
            {
                name: 'Techcombank',
                branch: 'Chi nhánh Kỳ Hòa - TP Hồ Chí Minh',
                accountNumber: '63096868',
                accountName: 'CÔNG TY TNHH TIDADIGI',
                transferNote: `nt${profile?.id}`
            }
        ];
        return (
            <><div className="">

                <div className='row'>

                    {/* <div className='col-12 d-flex justify-content-between my-2'>
                        <div className="buttons">
                            <button className="track-btn" >Theo dõi đơn hàng của bạn</button>
                        </div>
                    </div> */}

                </div>
                <div className='row'>
                    <div className='col-8'>
                        <div className="divbank">
                            <h3>Thông tin ngân hàng</h3>
                            {banks.map((bank, index) => (
                                <div key={index} className="bank-card">
                                    <svg
                                        style={{ width: "50%" }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 600 200"
                                        xmlSpace="preserve"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            fill="#ED1C24"
                                            d="M-276.003 30.993l-29.23 29.426 29.23 29.422-29.23 29.239-58.854-58.66 58.854-58.857 29.23 29.43m88.091 29.426l-58.657-58.857-29.434 29.431 29.434 29.426-29.434 29.422 29.434 29.239 58.657-58.661zM-322.13 159.903v11.573c-1.522-1.514-3.042-2.846-4.367-3.599-1.52-.761-3.042-1.141-4.754-1.141-3.027 0-5.5 1.141-7.395 3.225-1.901 2.092-2.853 4.747-2.853 8.163 0 3.225.951 5.699 2.853 7.783 1.894 2.092 4.367 3.227 7.395 3.227 1.712 0 3.234-.381 4.754-1.135 1.325-.768 2.846-2.092 4.367-3.612v11.586c-1.711.943-3.423 1.513-5.127 1.894-1.712.38-3.416.57-5.128.57-2.085 0-3.986-.191-5.88-.761-1.712-.38-3.425-1.324-4.938-2.274-3.044-1.903-5.128-4.367-6.839-7.403-1.514-3.044-2.275-6.269-2.275-10.064a22.4 22.4 0 011.514-8.164c.95-2.472 2.472-4.747 4.366-6.648 1.903-1.894 3.986-3.416 6.269-4.36 2.473-.95 4.938-1.331 7.783-1.331 1.712 0 3.416.191 5.128.57 1.704.38 3.416.943 5.127 1.901m-72.335 37.583v-39.103h10.636v15.185h14.235v-15.185h10.629v39.103h-10.629v-15.944h-14.235v15.944h-10.636zm-6.07-37.583v11.573c-1.523-1.514-2.854-2.846-4.367-3.599-1.529-.761-3.044-1.141-4.749-1.141-3.035 0-5.508 1.141-7.409 3.225-1.894 2.092-2.846 4.747-2.846 8.163 0 3.225.951 5.699 2.846 7.783 2.092 2.092 4.558 3.227 7.409 3.227 1.705 0 3.219-.381 4.749-1.135 1.513-.768 2.844-2.092 4.367-3.612v11.586c-1.712.943-3.425 1.513-5.13 1.894-1.703.38-3.225.57-4.936.57-2.283 0-4.177-.191-6.078-.761-1.705-.38-3.417-1.324-4.938-2.274-2.84-1.903-5.121-4.367-6.641-7.403-1.516-3.044-2.275-6.269-2.275-10.064 0-3.044.38-5.698 1.331-8.164a17.343 17.343 0 014.549-6.648c1.712-1.894 3.797-3.416 6.269-4.36 2.275-.95 4.74-1.331 7.783-1.331 1.711 0 3.233.191 4.936.57 1.706.38 3.418.943 5.13 1.901zm-59.425 37.583v-39.103h23.926v8.537h-13.48v6.839h12.713v8.353h-12.713v6.641h13.48v8.733h-23.926zm163.081-40.055v9.107c-3.036 0-5.319.959-7.409 3.233-1.896 2.085-2.847 4.938-2.847 8.164 0 3.414.951 6.071 2.847 8.352 1.901 2.086 4.373 3.227 7.409 3.227v8.924c-2.853 0-5.508-.38-7.981-1.522-2.655-.943-4.93-2.464-6.832-4.367a17.4 17.4 0 01-4.556-6.641c-1.135-2.472-1.514-5.127-1.514-7.972 0-2.847.38-5.317 1.514-7.783a17.484 17.484 0 014.556-6.65c1.902-1.894 4.177-3.414 6.832-4.556 2.473-.946 5.128-1.516 7.981-1.516zm-187.762 40.055v-29.989h-8.733v-9.114h28.095v9.114h-8.733v29.989h-10.629zm260.28 0h-9.875l-2.466-16.896c0-1.141-.191-2.655-.38-3.986-.192-1.516-.192-3.036-.381-4.749-.191 1.522-.753 3.606-1.514 6.08 0 .57-.189.95-.189 1.141l-5.319 18.41h-7.211l-5.317-18.41c0-.191-.191-.57-.381-1.141-.761-2.473-1.141-4.558-1.325-6.08-.189 1.522-.387 2.853-.387 4.369-.189 1.52-.372 2.851-.563 4.366l-2.281 16.896h-9.875l5.888-39.103h10.636l5.88 20.123c0 .189.191.38.191.753.572 1.711.951 3.233 1.142 4.564 0-.761.189-1.522.38-2.281.182-.951.381-1.896.761-3.036l6.071-20.123h10.438l6.077 39.103zm-72.518.951v-8.924c3.036 0 5.31-1.141 7.402-3.227 1.896-2.281 2.846-4.938 2.846-8.352 0-3.227-.95-5.882-2.846-8.164-2.092-2.274-4.556-3.233-7.402-3.233v-9.107c2.846 0 5.5.57 7.972 1.514 2.656 1.142 4.932 2.662 6.832 4.556 2.086 1.903 3.417 3.995 4.558 6.65.95 2.466 1.514 4.936 1.514 7.783 0 2.846-.564 5.5-1.514 7.972a17.395 17.395 0 01-4.558 6.641c-1.9 1.903-4.175 3.425-6.832 4.367-2.472 1.145-5.127 1.524-7.972 1.524z"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            fill="#231F20"
                                            d="M-208.796 173.947H-204.422v7.022H-208.795v8.544h4.373v7.972h-14.241v-39.103H-204.422v7.782H-208.796v7.783m42.908-15.565v6.261c-.38.95-.57 1.894-.761 2.853-.183.753-.38 1.703-.753 2.464l-3.803 12.91h5.317v7.594h-7.593l-2.092 7.021h-10.629l13.474-39.103h6.84zm-38.535 15.565c1.324-.189 2.466-.38 3.036-.761.944-.569 1.514-1.711 1.514-3.035 0-1.522-.38-2.472-1.331-3.233-.753-.381-1.703-.563-3.219-.755v-7.782c2.466 0 4.36.182 5.691.38 1.712.374 3.227.753 4.556 1.514a8.856 8.856 0 013.227 3.225c.761 1.331 1.141 2.854 1.141 4.558 0 2.283-.569 4.177-1.711 5.317-1.133 1.331-3.036 2.472-5.5 3.035 2.844.192 5.127 1.142 6.643 3.038 1.52 1.711 2.274 3.986 2.274 6.838 0 2.086-.374 3.988-1.331 5.509-.753 1.703-2.085 2.846-3.79 3.796-1.331.761-2.844 1.135-4.938 1.522-1.324.183-3.414.372-6.261.372v-7.972c2.086 0 3.606-.38 4.55-.951 1.141-.563 1.711-1.703 1.711-3.225 0-1.514-.57-2.655-1.522-3.416-.95-.572-2.464-.951-4.74-.951v-7.023zm109.158 23.539v-39.103h10.446v17.841l12.523-17.841h12.34l-14.424 19.171 15.755 19.932H-71.91l-12.91-17.46v17.46h-10.445zm-46.703 0v-39.103h10.255l14.805 20.123c.189.38.759 1.324 1.33 2.464.761 1.331 1.514 2.655 2.277 4.367-.185-1.514-.374-3.036-.564-4.177 0-1.331-.198-2.466-.198-3.416v-19.362h10.255v39.103h-10.255l-14.804-20.123c-.191-.38-.755-1.331-1.331-2.472-.762-1.324-1.325-2.838-2.086-4.36.192 1.522.381 3.036.381 4.36.191 1.141.191 2.283.191 3.233v19.362h-10.256zm-23.92-7.021v-7.594h5.317l-3.986-12.91c-.189-.38-.38-.95-.578-1.901-.183-.761-.563-1.896-.753-3.227v-6.45h6.648l13.482 39.103h-10.636l-2.083-7.021h-7.411z"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            fill="#ED1C24"
                                            d="M-192.85 109.396c-2.655 0-4.93 2.091-4.93 4.746 0 2.847 2.275 4.938 4.93 4.938v-.38c-2.464 0-4.558-1.896-4.558-4.558 0-2.464 2.094-4.366 4.558-4.366v-.38m-.944 2.282v2.275h.944v1.331l-.563-.761h-.381v3.036h-.57v-6.452H-192.849v.57h-.945zm.944 3.606v-.761l2.281 3.036h-.759l-1.522-2.275zm0 3.796c2.662 0 4.938-2.091 4.938-4.938 0-2.655-2.275-4.746-4.938-4.746v.38c2.473 0 4.556 1.901 4.556 4.366 0 2.662-2.083 4.558-4.556 4.558v.38zm0-5.127c.38 0 .57-.191.761-.191.197-.189.38-.563.38-.944 0-.38-.183-.759-.38-.95-.191 0-.381-.191-.761-.191v-.57c.57 0 .957.191 1.141.38.381.381.57.761.57 1.331 0 .564-.189.944-.57 1.135-.183.381-.57.57-1.141.57v-.57z"
                                        />
                                        <path
                                            fill="#ED1B24"
                                            d="M503.947 61.742c6.97 5.83 12.876 12.819 19.561 18.953-6.039 6.628-12.838 12.553-18.782 19.257 5.887 6.723 12.705 12.572 18.725 19.162-6.4 6.438-12.686 13.009-19.333 19.162-12.003-13.218-25.505-25.049-37.47-38.286 11.756-13.312 25.373-25.03 37.299-38.248zM542.177 61.723c13.351 12.268 25.752 25.562 38.704 38.248-12.952 12.629-25.277 25.961-38.647 38.134-5.754-6.742-12.458-12.534-18.459-19.048a1403.137 1403.137 0 0119.2-19.143c-6.343-6.571-13.579-12.401-19.067-19.732 6.304-5.925 12.647-11.869 18.269-18.459zM163.415 84.93c5.887-5.811 15.782-6.248 22.884-2.45a200.44 200.44 0 00-.095 10.692c-3.38-3.115-8.432-5.925-12.914-3.361-7.824 3.57-8.147 16.105-.475 20.017 4.539 2.849 9.875.19 13.389-3.039-.057 3.589-.038 7.16.038 10.749-7.16 3.38-16.94 3.437-22.79-2.507-8.526-7.444-8.564-22.637-.037-30.101zM19.119 80.942c9.249.171 18.497-.38 27.727.342a1226.35 1226.35 0 00-.19 8.451c-2.849-.019-5.716-.019-8.565-.038.133 9.781.057 19.58.057 29.361-3.361 0-6.742 0-10.103.019.038-9.724-.171-19.428.152-29.133a96.563 96.563 0 00-8.774-.152c-.114-2.943-.209-5.906-.304-8.85zM51.917 81.132c7.767-.285 15.554-.38 23.321.057.019 2.469.038 4.938.076 7.407-4.482.532-8.983.418-13.465.551l-.057 6.704c4.197.095 8.413.171 12.629.133v7.957c-4.159 0-8.318-.019-12.477-.076-.019 1.69-.038 5.09-.057 6.78 4.406.019 8.812 0 13.199-.057.095 2.735.171 5.469.285 8.185-7.824.551-15.687.342-23.511.133.342-12.591.266-25.183.057-37.774zM87.146 84.703c6.039-5.583 15.82-6.001 22.846-2.165a98.978 98.978 0 00.19 10.616c-3.551-2.659-7.9-5.697-12.534-3.741-8.926 3.153-8.964 17.89.019 21.004 4.615 2.051 9.021-1.026 12.325-3.988-.114 3.627-.114 7.255.038 10.882-6.685 3.475-15.744 3.665-21.783-1.253-9.685-7.18-10.084-23.455-1.101-31.355zM115.899 80.961c3.361 0 6.742-.019 10.103-.019-.019 4.957-.019 9.913-.019 14.87 4.71 0 9.439.038 14.148.076.057-4.976.133-9.951.095-14.927 3.361 0 6.723 0 10.084-.019.019 12.705.019 25.41 0 38.115-3.361 0-6.723 0-10.084.019.019-5.299.095-10.597-.209-15.877-4.729.114-9.439.19-14.167.266.152 5.204.152 10.407.114 15.592h-10.065V80.961zM202.138 81.835c10.673-4.9 24.974.57 28.24 12.192 4.216 11.661-5.28 25.467-17.643 25.771-11.889 1.595-23.549-9.42-21.973-21.441.247-7.178 5.242-13.275 11.376-16.522zm5.431 7.368c-8.85 3.38-8.907 18.308.019 21.65 6.096 2.431 13.028-2.621 13.389-8.964 1.71-7.463-5.754-15.857-13.408-12.686zM241.336 80.942c3.399.285 7.217-.798 10.35.741 2.925 7.274 3.229 15.801 7.426 22.41 1.728-7.843 4.14-15.516 6.571-23.169 3.323.038 6.647.038 9.97.038 2.203 12.667 4.026 25.391 5.944 38.096h-9.799c-.418-8.356-2.165-16.56-2.868-24.879-2.013 8.394-4.767 16.579-6.989 24.917-2.336-.019-4.672-.057-7.008-.095-2.127-8.356-4.368-16.712-7.274-24.841-.133 8.375-1.804 16.598-2.697 24.898h-9.61c2.053-12.686 3.971-25.411 5.984-38.116z"
                                        />
                                        <g>
                                            <path
                                                fill="#061822"
                                                d="M287.295 81.113c9.363.665 21.84-3.361 28.164 5.887 1.12 5.28-1.481 9.363-6.02 11.775 8.926.855 10.483 13.788 3.399 18.118-8.052 3.475-17.054 1.861-25.543 2.108a968.716 968.716 0 000-37.888zm9.344 7.179c.076 2.697.133 5.394.171 8.09 2.887-.456 9.629.779 9.021-4.102.474-5.052-6.211-3.399-9.192-3.988zm.114 14.338c0 2.944-.019 5.868-.057 8.831 3.76-.323 10.065 1.215 11.015-3.931.075-5.868-7.046-4.71-10.958-4.9zM332.475 80.961c4.311.019 8.641.019 12.971.038 3.95 12.8 8.641 25.372 12.99 38.059h-10.502a470.28 470.28 0 01-1.253-6.913c-5.128-.209-10.255-.171-15.364-.095-.988 2.222-.551 5.526-2.811 6.913-3.21.247-6.419.114-9.629.133 5.109-12.497 8.736-25.544 13.598-38.135zm.779 24.499c3.532-.608 7.141-.475 10.711-.323-1.101-6.115-4.026-11.756-4.558-18.004-2.773 5.85-3.912 12.288-6.153 18.327zM362.329 80.999c3.248 0 6.495-.019 9.762-.038 6.324 8.698 13.313 16.997 18.403 26.531-1.709-8.736-.798-17.681-1.139-26.512 3.323 0 6.647.019 9.97.019.019 12.686 0 25.372 0 38.059-3.21 0-6.419.019-9.629.038-6.362-8.717-13.066-17.187-18.497-26.512 1.937 8.698.798 17.643 1.083 26.474-3.323 0-6.628 0-9.951.019.074-12.705.074-25.392-.002-38.078zM407.908 80.999c3.342 0 6.685-.019 10.046-.019.019 5.64-.095 11.262-.019 16.902 4.577-5.09 8.147-11.053 11.851-16.807 4.083-.076 8.166-.114 12.268-.152-4.691 6.02-8.85 12.458-14.092 18.023 4.691 7.008 10.312 13.332 15.326 20.112-4.159 0-8.299 0-12.439.095-4.501-5.583-8.337-11.699-12.914-17.206-.057 5.697.019 11.414.019 17.111-3.342 0-6.704 0-10.046.019.076-12.705.076-25.392 0-38.078z"
                                            />
                                        </g>
                                    </svg>
                                    <h4>{bank.name}</h4>
                                    <p><strong>Chi nhánh:</strong> {bank.branch}</p>
                                    <p><strong>Số tài khoản:</strong> {bank.accountNumber}</p>
                                    <p><strong>Chủ tài khoản:</strong> {bank.accountName}</p>
                                    <p><strong>Nội dung:</strong> {bank.transferNote}</p>
                                    {/* <p><strong>Số tiền:</strong>
                                    </p> */}
                                    <p>Khi quý khách chuyển khoản vui lòng đợi từ 10 phút để nhân viên kiểm tra và cộng tiền cho quý khách</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='col-4'>
                        {banks.length > 0 && (
                            <div style={{ marginTop: "120px" }} className="">
                                <div className='col-4'>

                                </div>

                            </div>
                        )}
                    </div>

                </div>
            </div></>
        )
    }



    return (
        <div className="container-fluid">
            {loading && (
                <div className="spinner-overlay">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <Menu onLinkClick={setSelectedOption} />
            <div className={style.content}>
                <div className="row">
                    <div className="col-3">
                        <div className="d-flex">
                            <div className={`${style.sidebar} nav flex-column`} >

                                <a
                                    className={`${style.customlink} nav-link ${selectedOption === "Credit Card" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickThanhToanQuocTe}
                                >{t("International")} (Visa/master)</a>
                                <a
                                    className={`${style.customlink} nav-link ${selectedOption === "Paypal" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickThanhToanPayPal}
                                >Paypal</a>
                                <a
                                    className={`${style.customlink} nav-link ${selectedOption === "QR" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickThanhToanQR}
                                >{t("QR")}</a>
                                {/* <a
                                    className={`${style.customlink} nav-link ${selectedOption === "MoMo" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickMomo}
                                >MoMo</a> */}
                                <a
                                    className={`${style.customlink} nav-link ${selectedOption === "Thông tin thanh toán" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickThongtinthanhtoan}
                                >{t("Payment information")}</a>
                                <a
                                    className={`${style.customlink} nav-link ${selectedOption === "Atm" ? `${style.activelink} text-white` : ""}`}
                                    href="#"
                                    onClick={handleClickThanhToanNoiDia}
                                >{t("Domestic")} (ATM)</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-9">
                        {selectedOption === "Atm" && thanhToanNoiDia()}
                        {selectedOption === "Credit Card" && thanhToanQuocTe()}
                        {selectedOption === "QR" && thanhToanQR()}

                        {selectedOption === "Paypal" && thanhToanPayPal()}
                        {selectedOption === "Thông tin thanh toán" && thongTinThanhToan()}
                        {selectedOption === "" && thongTinThanhToan()}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Recharge;
